export default __webpack_public_path__ + "static/media/return-icon.d4c9b4ad.svg";